import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  deleteExpenseAttachment,
  deleteExpenseAttachmentWithId,
} from './expenseAttachment';
import { EXPENSE_ATTACHMENTS_KEY } from './useGetExpenseAttachments';
import { ExpenseFormType } from '@/pages/register/expenses/types';

interface DeleteExpenseAttachmentParams {
  attachmentUrl: string;
  expenseId?: number;
  expenseType?: ExpenseFormType;
}

export const useDeleteExpenseAttachment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      attachmentUrl,
      expenseId,
      // expenseType is needed to determine which cache to clear in onSuccess
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      expenseType,
    }: DeleteExpenseAttachmentParams) =>
      expenseId
        ? deleteExpenseAttachmentWithId(attachmentUrl, expenseId)
        : deleteExpenseAttachment(attachmentUrl),
    onSuccess: (_, { expenseId, expenseType }) => {
      /*
       * when we have an expenseId, we have deleted an attachment from an
       * existing expense and need to clear the specific expense cache entry
       */
      if (expenseId) {
        queryClient.removeQueries({
          queryKey: [EXPENSE_ATTACHMENTS_KEY, expenseId, expenseType],
        });
      }
    },
  });
};
